<template>
	<div class="moderation">
		<Titlebar title="Vote Moderation" />
		<Loading v-if="state === 'loading'" />
		<div v-else-if="state === 'empty'">
			<Card>
				<h2>
					Couldn&apos;t find any un-archived campaigns to run moderation on.
				</h2>
			</Card>
		</div>
		<div v-else-if="state === 'ready'">
			<Card class="filters">
				<ModerationFiltersForm :campaigns="campaigns" />
			</Card>
			<router-view />
		</div>
		<Card v-else>
			<h2>Something went wrong, please try again.</h2>
		</Card>
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import Titlebar from '@/components/admin/Titlebar'
import Card from '@/components/shared/Card'
import Loading from '@/components/shared/Loading'
import ModerationFiltersForm from '@/components/admin/ModerationFiltersForm'
import mounted from '@/mixins/mounted'

export default {
	name: 'VoteModeration',
	data() {
		return {
			status: 0,
			activeCampaign: null,
			campaigns: []
		}
	},
	computed: {
		campaignId() {
			const id = Number(this.$route.params.id)
			return isNaN(id) ? null : id
		},
		state() {
			if (this.status > 200) {
				return 'error'
			} else if (this.status === 200 && this.campaignId !== null) {
				return this.campaigns.length > 0 ? 'ready' : 'empty'
			} else {
				return 'loading'
			}
		}
	},
	methods: {
		loadActiveOrRecentCampaign() {
			if (this.campaigns.length > 0) {
				const id = this.activeCampaign
					? this.activeCampaign.id
					: this.campaigns[0].id
				this.setCampaign(id, 'replace')
			}
		},
		setCampaign(id, action = 'push') {
			if (!this.mounted) return
			this.$router[action]({ name: 'Moderate Campaign', params: { id } })
		}
	},
	async created() {
		try {
			const [resActive, resCampaigns] = await Promise.all([
				this.get('/campaigns/active'),
				this.get('/campaigns/moderation')
			])

			if (resCampaigns.status !== 200) {
				this.status = resCampaigns.status
				return
			}
			this.campaigns = await resCampaigns.json()

			if (resActive.status === 200) {
				this.activeCampaign = await resActive.json()
			}

			this.status = resCampaigns.status
			if (this.campaignId === null) {
				this.loadActiveOrRecentCampaign()
			}
		} catch (error) {
			this.status = 500
		}
	},
	watch: {
		campaignId(next) {
			if (next === null) this.loadActiveOrRecentCampaign()
		}
	},
	mixins: [api, toast, mounted],
	components: {
		Titlebar,
		Card,
		Loading,
		ModerationFiltersForm
	}
}
</script>

<style lang="scss" scoped>
.filters {
	margin-bottom: 3rem;
}
</style>
